





















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../components/nav-left.vue";
import PatientList from "./patient-list.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    PatientList,
  },
})
export default class ZbsjkList extends Vue {
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }
  /**
   * @description 初始化
   */
  private mounted() {
    // if (this.$route.query) {
    //   this.name = this.$route.query["name"];
    //   this.type = this.$route.query["type"];
    //   this.projectId = this.$route.query["project_id"];
    // }
  }
}
